export default __webpack_public_path__ + "static/media/linkedin.e65fd24a.png";